import { Config } from "@itarget/shared";
import {
  readAssociationId,
  buildPersonMeUrl as buildSharedPersonMeUrl,
  buildStatusAssociatedUrl as buildSharedStatusAssociatedUrl,
} from "@itarget/shared/src/utils/association";

export { readAssociationId };

export function buildPersonMeUrl() {
  return buildSharedPersonMeUrl({ baseURLV2: Config.baseURLV2 });
}

export function buildStatusAssociatedUrl({ language, associationId, centerCostId }) {
  return buildSharedStatusAssociatedUrl({
    baseURL: Config.baseURL,
    language,
    associationId,
    centerCostId,
  });
}
